module.exports = __webpack_public_path__ + "img/135x90-04.db87ba69.png";